import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "lumen_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, variant, qty = 1) => {
    const variant_id = variant?.id || null;
    const price = variant?.selling_price ?? product.selling_price;
    const max_stock = variant?.stock ?? product.stock;
    const label = variant ? [variant.color, variant.size].filter(Boolean).join(" / ") : null;
    setItems((prev) => {
      const key = product.id + (variant_id || "");
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => i.key === key ? { ...i, quantity: Math.min(i.quantity + qty, max_stock) } : i);
      }
      return [...prev, {
        key, product_id: product.id, variant_id, slug: product.slug, title: product.title,
        image: (product.images || [])[0], variant_label: label, price, quantity: qty, max_stock,
      }];
    });
    toast.success(`${product.title} added to cart`);
  };

  const update = (key, qty) => setItems((prev) =>
    prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, Math.min(qty, i.max_stock)) } : i));
  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}
